<template>
  <transaction-blank-form
    submit-label="Добавить транзакцию"
    :transaction="transaction"
    :errors="errors"
    form-type="add"
    @submit="processTransactionForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { addTransaction } from '@/services/transaction.service'
import transactionBlankForm from '@/components/forms/transaction/TransactionBlankForm'

export default {
  name: 'transaction-add-form',
  components: { transactionBlankForm },
  props: {
    client: {
      type: [Number]
    }
  },
  data () {
    return {
      transaction: {
        id: null,
        amount: '',
        transaction_type: '',
        datetime: '',
        notation: '',
        client: this.client
      },

      errors: {
        transaction: {
          id: [],
          amount: [],
          transaction_type: [],
          datetime: [],
          notation: [],
          client: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processTransactionForm () {
      this.addTransaction().then((success) => {
        if (success) {
          this.showMsg('Транзакция была успешно добавлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    addTransaction () {
      return addTransaction(this.transaction).then((response) => {
        this.transaction = response.data
        this.fillErrors(this.errors.transaction, {})
        return true
      }).catch(err => {
        console.log(err.response)
        this.fillErrors(this.errors.transaction, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// TransactionAddForm.vue?cd1be262